import { Button } from "@mui/material";
import { SHOW_REFERNCE_DETAILS } from "./constants";
import styles from "./styles.module.css";

interface Props {
  handleModal: () => void;
}

const TransactionDetails = ({ handleModal }: Props) => {
  return (
    <Button onClick={handleModal} className={styles["text"]}>
      {SHOW_REFERNCE_DETAILS}
    </Button>
  );
};

export default TransactionDetails;
